import React from "react";

import { useMaximizeScrollContainer } from "@kikoff/hooks/src/useContentHeight";
import { cls } from "@kikoff/utils/src/string";

import styles from "./with_footer.module.scss";

interface WithFooterProps {
  // This is optional since this component can be used for alignment
  footer?: React.ReactNode;
  noBottomPadding?: boolean;
  className?: string;
}

const WithFooter: React.FC<WithFooterProps> = ({
  footer,
  noBottomPadding = false,
  className,
  children,
}) => {
  const ref = useMaximizeScrollContainer();

  return (
    <div className={cls(styles["with-footer"], className)}>
      <div ref={ref}>{children}</div>
      {footer && (
        <footer className={cls(noBottomPadding && styles["no-bottom-padding"])}>
          {footer}
        </footer>
      )}
    </div>
  );
};

export default WithFooter;
